import moment from 'moment-timezone'

export default {
  methods: {
    formatDate (date, format = 'DD-MM-YY HH:mm:ss', lang = 'es') {
      return moment(new Date(parseInt(date))).lang(lang).format(format)
    },
    formatMoney (amount) {
      return parseInt(amount).toLocaleString('en', { style: 'currency', currency: 'USD' })
    },
    getRoleName (role) {
      const roleName = role.code === 'custom' && role.name
        ? role.name
        : this.$t(`roles.${role.code}`, this.systemConfiguration.lang)
      return roleName
    },
    humanDate (date, format = 'DD-MMMM-YYYY', time = false, lang = 'en') {
      date = !Number.isNaN(Number(date)) ? parseInt(date) : date
      moment.locale(lang)
      const formatString = format || (time ? 'DD-MMMM-YYYY HH:mm:ss' : format)
      return moment(date).format(formatString)
    },
    enmascararEmail (email) {
      const [usuario, dominio] = email.split('@')
      const visible = usuario.slice(0, 3) // primeros 3 caracteres
      const oculto = '*'.repeat(usuario.length - 3)
      return `${visible}${oculto}@${dominio}`
    }
  }
}
